import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const DrivingExperience = (props) => {
  return (
    <FormGroup controlId="drivingExperience">
      <Col componentClass={ControlLabel} sm={5}>
        Driving Experience
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="drivingExperience"
              value={props.drivingExperience}
              onChange={props.handleChangeDrivingExperience}
              onBlur={() => props.validation(true)}
            >
              <option value="">Please select</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5+">5+</option>
            </select>
      </Col>
    </FormGroup>
  )
}

DrivingExperience.propTypes = {
  drivingExperience: PropTypes.string,
  handleChangeDrivingExperience: PropTypes.func,
  validation: PropTypes.func
};

export default DrivingExperience;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/drivingExperience/DrivingExperience.js